import {FC} from 'react';

interface Props {
  className?: string;
}

const UserIcon: FC<Props> = ({className = ''}) => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>
    <path
      id="User"
      d="M2.105 14C2.615 11.631 4.938 10 8 10C11.117 10 13.405 11.601 13.9 14H2.105ZM5 5C5 3.346 6.346 2 8 2C9.654 2 11 3.346 11 5C11 6.654 9.654 8 8 8C6.346 8 5 6.654 5 5ZM11.435 8.615C12.394 7.704 13 6.425 13 5C13 2.243 10.757 0 8 0C5.243 0 3 2.243 3 5C3 6.425 3.606 7.704 4.565 8.615C1.796 9.68 0 12.041 0 15C0 15.553 0.448 16 1 16H15C15.552 16 16 15.553 16 15C16 12.041 14.204 9.68 11.435 8.615Z"
      fill="white"
    />
  </svg>
);

export default UserIcon;
